import { FeatureStatus } from '@/hooks/useFeatures';
import { tokens } from '@/modules/utils/themeUtils';
import {
  Breakpoints,
  Text,
  styled,
} from '@volkswagen-onehub/components-core';

interface StyledFeatureBox {
  status: FeatureStatus;
}

interface StyledFeatureTextProps {
  status: FeatureStatus;
}

export const StyledFeatureBox = styled.div<StyledFeatureBox>(
  ({ theme, status }) => {
    const backgroundColours = {
      [FeatureStatus.NOT_AVAILABLE]: tokens(theme).globalColors.disabledBeige,
      [FeatureStatus.NOT_INCLUDED]: tokens(theme).globalColors.vLightBeige,
      [FeatureStatus.STANDARD]: tokens(theme).globalColors.lightBeige,
      [FeatureStatus.STANDARD_SPEC]: tokens(theme).globalColors.lightBeige,
      [FeatureStatus.OPTIONAL_EXTRA]: tokens(theme).globalColors.lightBeige,
      [FeatureStatus.REPLACED]: tokens(theme).globalColors.lightBeige,
    };

    return `
    background-color: ${backgroundColours[status]};
    opacity: ${status === FeatureStatus.NOT_AVAILABLE ? '0.2' : '1'};
    padding: ${theme.size.static150} ${theme.size.static350};
    border-radius: ${theme.size.static150};
    width: 100%;

    @media (min-width: ${Breakpoints.b960}px) {
      padding: ${theme.size.static200} ${theme.size.static350};
    }
`;
  }
);

export const StyledFeatureText = styled(Text)<StyledFeatureTextProps>(
  ({ theme, status }) => {
    const textColours: Record<FeatureStatus, string> = {
      [FeatureStatus.NOT_AVAILABLE]: theme.colors.content.disabled,
      [FeatureStatus.NOT_INCLUDED]: theme.colors.content.secondary,
      [FeatureStatus.STANDARD]: theme.colors.content.primary,
      [FeatureStatus.STANDARD_SPEC]: theme.colors.content.primary,
      [FeatureStatus.OPTIONAL_EXTRA]: theme.colors.content.primary,
      [FeatureStatus.REPLACED]: theme.colors.content.primary,
    };

    return `
      color: ${textColours[status]};
    `;
  }
);
